import { DEFAULT_FETEBUDDY_INITIATE_MESSAGES } from "constants/llm";
import { useEffect, useReducer, useState } from "react";
import { useLocation } from "react-router-dom";
import { createChatSession, deleteChatMessage, getChatSessions, getSessionMessages, updateChatMessage, updateChatSession } from "services/chat";
import { createPrompt, generateImage, getChatHistory, searchPrompts, updatePrompt } from "services/llm";
import { getLLMAgentCreateImagePayload } from "services/llm/payloads";
import { GetChatSessionsByMetadata } from "types";
import { CreatePromptPayload, UpdatePromptPayload } from "types/prompt.types";

const initialArgs = {
  shouldFetchMessages: true,
  showChatLoader: false,
  messageHistory: []
};

const reducer = (state: any, action: any) => {
  return { ...state, ...action };
};

const useMessages = () => {
  const [state, setState] = useReducer(reducer, initialArgs);
  const location = useLocation();
  
  const resetStateToDefaults = () => {
    setState({ ...initialArgs })
  }

  useEffect(() => {
    resetStateToDefaults();
  }, [location.pathname]);

  const filterMessagesWithInitAndOtherMessages = (messages: any) => {
    const actualMessages : any = [];
    if(messages?.length > 0) {
      for (let index = 0; index < messages.length; index++) {
        const message = messages[index];
        actualMessages.push(message)
        // if(message?.content !== DEFAULT_FETEBUDDY_INITIATE_MESSAGES.CONTINUE && message?.content !== DEFAULT_FETEBUDDY_INITIATE_MESSAGES.START) {
        // } else {
        //   if(!actualMessages.includes(messages[index+1])){
        //     actualMessages.push(messages[index+1])
        //   }
        //   index++;
        // }
      }
    }
    return actualMessages;
  }

  const retriveChatHistory = async (session_id: string) => {
    try {
      const { data } = await getChatHistory(session_id);
      return filterMessagesWithInitAndOtherMessages(data?.chat_history?.chat_memory?.messages || []);
    } catch (error) {
      console.error('getChatHistory>>>',error);      
    }
  }

  const createSession = async (payload: any) => {
    try {
      const { data } = await createChatSession(payload);
      return data;
    } catch (error) {
      console.error('createSession>>>',error);      
    }
  }

  const getUserChatSessions = async (payload: GetChatSessionsByMetadata) => {
    try {
      const chatSessionRes = await getChatSessions(payload);
      return chatSessionRes;
    } catch (error) {
      console.error('getChatSessions>>>',error);      
    }
  }

  const getUserChatSessionMessages = async (session_id: string) => {
    try {
      const sessionMessages: any = await getSessionMessages(session_id);
      return sessionMessages?.messages || [];
    } catch (error) {
      console.error('getChatSessionsMessages>>>',error);      
    }
  }

  const updateSessionTitle = async (session_id: string, title: string) => {
    try {
      const { data } = await updateChatSession(session_id, { title: title });
      return data;
    } catch (error) {
      console.error('updateChatSessions>>>',error);      
    }
  }

  // const updateMessageContent = async (message_id: string, content: string) => {
  //   try {
  //     const { data } = await updateChatMessage(message_id, { content: content });
  //     return data;
  //   } catch (error) {
  //     console.error('updateChatMessage>>>',error);      
  //   }
  // }

  const updateMessageContent = async (message_id: string, payload: any) => {
    try {
      const { data } = await updateChatMessage(message_id, payload);
      return data;
    } catch (error) {
      console.error('updateChatMessage>>>',error);      
    }
  }

  const createImageFromPrompt = async (prompt: string) => {
    try {
      const { data } = await generateImage(getLLMAgentCreateImagePayload({
        prompt: prompt
      }));
      return data;
    } catch (error) {
      console.error('updateChatMessage>>>',error);      
    }
  }

  const deleteMessage = async (message_id: string) => {
    try {
      const { data } = await deleteChatMessage(message_id);
      return data;
    } catch (error) {
      console.error('updateChatMessage>>>',error);      
    }
  }

  return {
    setState,
    retriveChatHistory,
    getUserChatSessions,
    getUserChatSessionMessages,
    updateMessageContent,
    updateSessionTitle,
    createImageFromPrompt,
    createSession,
    deleteMessage,
    ...state,
  };
};

export default useMessages;
